<script>
  import { onMount, createEventDispatcher } from "svelte";
  let dispatch = createEventDispatcher();
  import { Username, changePasswordThrough } from "./store.js";

  onMount(async function() {
    if ($Username.value == '')
      dispatch("pageChange", "/account/login");
  });
</script>

<form action="" class="box">
  <h1 class="title is-5">Password Reset Successfully </h1>
  <p>
    Password for <strong>{$Username.value}</strong> has been successfully updated and sent to you via <strong>{$changePasswordThrough}</strong>.
  </p>
  <div style="text-align: right; margin-top: 15px;">
    <a href="/signin/{$Username.value}/" class="button is-purple">Login to eAdmissions</a>
  </div>
</form> 